import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Create a mock client if env vars are missing (for development)
let supabase: ReturnType<typeof createClient>;

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn('⚠️ Supabase environment variables missing. Using mock client.');
  // Create a mock client with dummy values
  supabase = createClient(
    'https://placeholder.supabase.co',
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InBsYWNlaG9sZGVyIiwicm9sZSI6ImFub24iLCJpYXQiOjE2NDUxOTIwMDAsImV4cCI6MTk2MDc2ODAwMH0.placeholder'
  );
} else {
  supabase = createClient(supabaseUrl, supabaseAnonKey);
}

export { supabase };

// Types voor de database
export type Strippenkaart = {
  id: string;
  user_id: string;
  resterende_strippen: number;
  totaal_strippen: number;
  gekocht_op: string;
  archived: boolean;
};

export type Betaalwijze = 'stripe' | 'strippenkaart' | 'paypal' | 'contant' | 'factuur' | 'gratis' | 'anders' | null;

export type EventRegistration = {
  id: string;
  user_id: string | null;
  event_id: string;
  event_datum: string;
  event_tijd: string;
  event_locatie: string;
  rol: 'representant' | 'vraagsteller' | null;
  strippenkaart_id: string | null;
  checkout_session_id: string | null;
  email: string | null;
  voornaam?: string | null;
  achternaam?: string | null;
  telefoon?: string | null;
  organisatie?: string | null;
  bericht?: string | null;
  betaald_bedrag?: number | null;
  betaalwijze?: Betaalwijze;
  aangemeld_op: string;
  status: 'bevestigd' | 'geannuleerd' | 'aanwezig';
};

export type Database = {
  public: {
    Tables: {
      strippenkaarten: {
        Row: Strippenkaart;
        Insert: Omit<Strippenkaart, 'id' | 'gekocht_op'>;
        Update: Partial<Omit<Strippenkaart, 'id' | 'gekocht_op'>>;
      };
      event_registrations: {
        Row: EventRegistration;
        Insert: Omit<EventRegistration, 'id' | 'aangemeld_op'>;
        Update: Partial<Omit<EventRegistration, 'id' | 'aangemeld_op'>>;
      };
    };
  };
};

